export function preferencesUseTimeJson (language) {
  let items

  if (language === 'es') {
    items = {
      restriction: { // restricción por días y horarios
        name: 'restriction',
        label: 'visualizar el tiempo de uso autorizado por días y horarios'
      },
      editRestrictionSettings: { // días, hora de inicio, hora de finalización
        name: 'editRestrictionSettings',
        label: 'activar y editar el tiempo de uso autorizado por días y horarios'
      }
    }
  } else if (language === 'en') {
    items = {
      restriction: { // restricción por días y horarios
        name: 'restriction',
        label: 'view the authorized usage time by days and times'
      },
      editRestrictionSettings: { // días, hora de inicio, hora de finalización
        name: 'editRestrictionSettings',
        label: 'Activate and edit the authorized usage time by days and times'
      }
    }
  }

  return (items)
}
